module.exports = __webpack_public_path__ + "img/Georgia.37e24437.gif";